// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"418":"031ae87e","679":"7a7c5fa8"}[chunkId] + ".chunk.js";
};